import { useMatchMedia } from '@xing-com/crate-hooks-use-match-media';
import { mediaConfined } from '@xing-com/layout-tokens';

/**
 * @deprecated: This hook doesn't work great with SSR, please use CSS instead if
 * you can.
 */
export const useIsDesktop = (): boolean | undefined => {
  const media = mediaConfined;

  const matches = useMatchMedia(media);

  return matches;
};
